import { Box, Button, Chip, List, ListItem, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PatientSummary, Visit } from '../../store/patientsSlice';

interface PatientInfoVisitsProps {
  patient: PatientSummary;
}

export const PatientInfoVisits: React.FC<PatientInfoVisitsProps> = ({ patient }) => {
  const visits = patient.visits ? patient.visits : [];
  const [selectedVisit, setSelectedVisit] = useState<Visit>();
  const navigate = useNavigate();

  useEffect(() => {
    if (visits.length > 0) {
      setSelectedVisit(visits[0]);
    }
  }, [visits]);

  const addVisit = () => {
    navigate(`/patient/${patient.id}/new-visit`);
  };

  return (
    <>
      <Grid container sx={{ mt: 2 }}>
        <Grid offset={1} size={3}>
          <Typography sx={{ fontSize: '1rem', color: 'primary.main', fontWeight: 'bold' }}>Visites</Typography>

          <List dense>
            {visits.map((visit, index) => (
              <ListItem
                key={index}
                onClick={() => {
                  setSelectedVisit(visit);
                }}
                sx={{
                  backgroundColor: selectedVisit === visit ? 'primary.light' : 'inherit',
                  fontWeight: selectedVisit === visit ? 'bold' : 'normal',
                  cursor: 'pointer',
                }}
              >
                <ListItemText
                  primary={format(new Date(visit.date), "dd MMM yyyy HH'h'mm")}
                  primaryTypographyProps={{
                    fontWeight: selectedVisit === visit ? 'bold' : 'normal',
                    color: selectedVisit === visit ? 'primary.main' : 'inherit',
                  }}
                />
              </ListItem>
            ))}
          </List>
          <Button color="primary" onClick={addVisit} variant="contained">
            + Nouvelle visite
          </Button>
        </Grid>
        <Grid offset={1} size={7}>
          {selectedVisit && (
            <Box
              sx={{
                m: 1,
                p: 1,
                height: '100%',
                backgroundColor: 'primary.light',
                borderRadius: '10px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1rem',
                  color: 'primary.main',
                  fontWeight: 'bold',
                }}
              >
                Visite {format(new Date(selectedVisit.date), "dd MMM yyyy HH'h'mm")}
              </Typography>
              <ListItem>
                <ListItemText primary="Traitement en cours" />
              </ListItem>
              {selectedVisit.medications?.map((med) => (
                <Chip
                  key={med.id}
                  label={`${med.name} ${med.quantity}${med.unit}, ${med.frequency} x par jour, débuté en ${format(new Date(med.startDate), 'MMM yy')}.`}
                  size="small"
                  sx={{
                    color: 'primary.main',
                    backgroundColor: 'primary.light',
                    mb: 1,
                    fontWeight: 'medium',
                    borderColor: 'primary.main',
                  }}
                  variant="outlined"
                />
              ))}
              <List>
                <ListItem>
                  <ListItemText primary="Diagnostic" secondary={selectedVisit.newDiagnostic} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Tentative de suicide" secondary={selectedVisit.suicideAttempt ? 'oui' : 'non'} />
                </ListItem>
              </List>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default PatientInfoVisits;
